<template>
  <div class="app__klarna__wrapper js__product__klarna">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.app__klarna__wrapper {
  margin-bottom: 0.125rem; // 2px margin below the widget for spacing
}
</style>
